import leaveRule from "@/api/human-resource/leave-rule";
import { baseState, baseMutations } from "@/store/mixins";

export const state = {
    ...baseState,
    employeeTypes: [],
    leaveTypes: []
};

export const getters = {};

export const mutations = {
    ...baseMutations,
    SET_EMPLOYEETYPE(state, data) {
        state.employeeTypes = data;
    },
    SET_LEAVE_TYPE(state, data) {
        state.leaveTypes = data;
    }
};

export const actions = {
    fetch(context, attributes = {}) {
        const params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attributes
        );
        return leaveRule.get({ params }).then(response => {
            context.commit("RECEIVE_RESOURCES", response);
            return Promise.resolve(response);
        });
    },

    store(context, data) {
        return leaveRule.store(data);
    },

    async getEmployeeType(context, attributes = {}) {
        let response = await leaveRule.employeeType({
            params: attributes
        });
        context.commit("SET_EMPLOYEETYPE", response.data);
    },
    async getLeaveType(context, attributes = {}) {
        let response = await leaveRule.leaveType({
            params: attributes
        });
        context.commit("SET_LEAVE_TYPE", response.data);
    }
};
